import {Spin as AntSpin} from "antd";

export const Spin = AntSpin;
export default Spin;
